import { isOrHandleAsExternalUrl } from "../../../helpers";
import { TLink } from "../../../types/link-types";
import { PrimaryButtonLink, SecondaryButtonLink } from "../button/button";
import styles from "./info-box.module.less";

export type TInfoBoxProps = {
  heading?: string;
  text?: string;
  link?: TLink;
  buttonType?: "primary" | "secondary";
};

export const InfoBox = ({ heading, text, link, buttonType = "primary" }: TInfoBoxProps) => {
  return (
    <div className={styles.wrapper}>
      {heading && <p className={["h5", styles.heading].join(" ")}>{heading}</p>}
      {text && <div className={"body-s"} dangerouslySetInnerHTML={{ __html: text ? text : "" }}></div>}
      <div className={[styles.content].join(" ")} />
      {link && (
        <div className={styles.buttonWrapper}>
          {buttonType === "primary" ? (
            <PrimaryButtonLink
              url={link?.url}
              iconRight={link?.icon ?? "ui-icon-arrow-right"}
              label={link?.title}
              openInNewTab={isOrHandleAsExternalUrl(link?.url, link?.target)}
            />
          ) : (
            <SecondaryButtonLink
              url={link?.url}
              iconRight={link?.icon ?? "ui-icon-arrow-right"}
              label={link?.title}
              openInNewTab={isOrHandleAsExternalUrl(link?.url, link?.target)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default InfoBox;
